export const INSTAGRAM_COLOR = 'rgb(162 39 172)';
export const WHATS_APP_COLOR = '#10ba10';
export const VK_COLOR = 'rgb(2, 119, 255)';
export const EMAIL_COLOR = 'rgb(2, 119, 255)';
export const TELEGRAM_COLOR = 'rgb(2, 119, 255)';
export const MAX_MESSENGER_COLOR = 'rgb(30, 0, 255)';
export const LOYALTY_PROGRAM_SENDOUTS_COLOR = 'rgb(32, 23, 98)';
export const NEW_LEAD_INTEGRATION_COLOR = 'rgb(160 65 213)';
export const SMS_SERVICE_COLOR = 'rgb(0, 150, 136)';
export const TECH_SUPPORT_COLOR = 'rgb(250, 140, 22)';
